//import * as lib from '../lib/lib'
import $ from 'jquery';
import jQuery from 'jquery';

class StickyTabs {
    constructor(element) {
        if (!element) return

        this.element = element
            
        $(window).on('scroll', (_) => {
           // api.winTop = $(window).scrollTop();
            this._stickySearch()
          })
          this._stickySearch()
    }

   
    _stickySearch() {
        var tabsOffset = $(this.element).offset().top
        const headerOuterHeight =  $('.header__layer').outerHeight()

        if ( $(window).scrollTop() + headerOuterHeight > tabsOffset) {
            $(this.element).find('.s-mutual-funds__sticky').addClass('is-sticky')
        } else {
            $(this.element).find('.s-mutual-funds__sticky').removeClass('is-sticky')
        }
      }
}

export default StickyTabs
